module.exports = __webpack_public_path__ + "static/media/awarded-penalty.b70ae545.svg";